import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";

const metricProcessName = "SCC_PACKAGE_SEARCH";
export async function getPackageHistoryData(packageId, pageSize, pageToken = null,
     fromEpoch = null, toEpoch = null) {
    
    const requestBody = {
        "packageId": packageId,
        "pageSize": pageSize,
        "pageToken": pageToken,
        "startTime": fromEpoch,
        "endTime": toEpoch
    }

    const startTime = Date.now();

    const request = {
        resourcePath: "/os/getPackageHistoryData",
        httpMethod: "post",
        processName: "oculus",
        requestBody: requestBody
    }

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getPackageHistoryData", true);
            return response.data;
        } else {
            logOperationalMetric(startTime, metricProcessName, "getPackageHistoryData", false);
            return {
                packageHistory: [],
                nextPageToken: null
            };
        }
    } catch (error) {
        return {
            packageHistory: [],
            nextPageToken: null
        }
    }

}


// WEBPACK FOOTER //
// ./src/commons/api/GetPackageHistoryResults.js